import React from "react";
import ScrollArea from "react-scrollbars-custom";

import ColumnsToolsBlock from "./tools/ColumnsToolsBlock";
import ItemsToolsBlock from "./tools/ItemsToolsBlock";
import ElementsButton from "./ElementsButton";

const Tools = ({ creatorMode, adminMode, toggleElements, onCollapsed }) => {
  return (
    <div className="fantastic-sidebar__body fantastic-sidebar__body--flexed-scrollbar-content fantastic-tools">
      <ScrollArea noDefaultStyles={true}>
        <ColumnsToolsBlock onCollapsed={onCollapsed} />
        <ItemsToolsBlock creatorMode={creatorMode} adminMode={adminMode} />
        <ElementsButton type="CollectionEntity" onClick={toggleElements} />
      </ScrollArea>
    </div>
  );
};

export default Tools;
